import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {SeparateHsvSockets} from "#material/nodes/converter/separate-hsv/definition"
import {separateHsvDefinition} from "#material/nodes/converter/separate-hsv/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeRGBColor, threeRgbToHsv} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {SeparateHsvNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class SeparateHsv extends MaterialNode<SeparateHsvSockets> {
    public override get definition() {
        return separateHsvDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<SeparateHsvSockets>> => {
        const color =
            (await evaluator.get(this.parameters.inputs.image))?.toColor() ??
            threeRGBColor({r: this.parameters.settings.h ?? 0, g: this.parameters.settings.s ?? 0, b: this.parameters.settings.v ?? 0})
        const hsv = threeRgbToHsv(color)
        return {h: hsv.r, s: hsv.g, v: hsv.b}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<SeparateHsvSockets>> => {
        const separateHsv: SeparateHsvNode = {
            type: "separate_hsv",
            inputs: {color: await evaluator.get(this.parameters.inputs.image)},
            parameters: {color: cyclesColor(this.parameters.settings.image)},
            resources: {},
        }

        return {h: [separateHsv, "h"], s: [separateHsv, "s"], v: [separateHsv, "v"]}
    }
}
